import React from 'react';

import { Box } from '@mui/material';
import { MAIN_CONTENT_ID } from 'shared/constants/mainContent';

export type PageContainerProps = {
  children: React.ReactNode;
  headerElement?: React.ReactNode;
  footerElement?: React.ReactNode;
};

export const PageContainer: React.VFC<PageContainerProps> = ({
  children,
  headerElement,
  footerElement,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {headerElement}
      <Box
        id={MAIN_CONTENT_ID}
        tabIndex={-1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
      {footerElement}
    </Box>
  );
};
